/**
 * External Dependencies
 */
import 'jquery';
import 'alpinejs';

window.Flickity = require('flickity');

$(document).ready(() => {
  // console.log('Hello world');
});
